/* eslint max-lines: off */
import { Reducer } from 'redux'
import {
  ActionTypes,
  STRAITSX_LANDING_PAGE_ACTIONS,
  DashboardBanner,
  Blockchain,
  StablecoinFee,
  FiatFee,
  WithdrawWalletIdType,
} from './types'
import { TRANSFER_METHOD } from '~/biz/store/straitsXLandingPage/types'
import { BankAccount, CURRENCY, BANK_TRANSFER_NETWORK } from '~/types'
import { BlockchainAddress } from '~/biz/store/blockchainAddresses/types'
import { ACCEPTED_CURRENCY } from '~/biz/types'
import { landingPage as commonLandingPageReducer } from '~/store/landing/reducer'

const initialState: State = {
  // business account related fields
  currentMerchantAccountId: null,

  isXsgdErc20DepositEnabled: true,
  isXsgdErc20WithdrawalEnabled: true,
  isXsgdZrc2DepositEnabled: true,
  isXsgdZrc2WithdrawalEnabled: true,
  isXsgdHtsDepositEnabled: false,
  isXsgdHtsWithdrawalEnabled: false,
  isXsgdMaticDepositEnabled: false,
  isXsgdMaticWithdrawalEnabled: false,
  isXsgdAvaxDepositEnabled: false,
  isXsgdAvaxWithdrawalEnabled: false,
  isXsgdArbDepositEnabled: false,
  isXsgdArbWithdrawalEnabled: false,
  isXsgdXrpDepositEnabled: false,
  isXsgdXrpWithdrawalEnabled: false,
  isUsdcErc20DepositEnabled: false,
  isUsdcErc20WithdrawalEnabled: false,
  isUsdtTrc20DepositEnabled: false,
  isUsdtTrc20WithdrawalEnabled: false,
  isXusdErc20DepositEnabled: false,
  isXusdErc20WithdrawalEnabled: false,
  isXusdBep20DepositEnabled: false,
  isXusdBep20WithdrawalEnabled: false,
  isUsdcMaticDepositEnabled: false,
  isUsdcMaticWithdrawalEnabled: false,
  isUsdtBep20DepositEnabled: false,
  isUsdtBep20WithdrawalEnabled: false,

  isDashboardBannerManagementEnabled: false,
  isFazzVaForDashboardEnabled: false,
  isSsoTwoFaAuthenticatorEnabled: false,
  isTravelRuleDepositDeclarationEnabled: false,
  isTravelRuleAddrWhitelistingEnabled: false,
  isXusdCoachmarkActive: false,

  isDashboardApprovalFlowUIEnabled: false,

  dashboardBanners: [],

  tab: 'deposit',
  transferMethod: null,
  bankTransferNetwork: null,
  selectedCurrency: null,
  selectedBlockchain: null,
  selectedBankAccount: null,
  selectedBlockchainAddress: null,

  withdrawAmount: '',
  withdrawAmountError: '',
  withdrawRequestError: '',
  withdrawWalletId: undefined,
  transferRemark: '',

  isStablecoinFeeLoading: false,
  stablecoinFee: {
    amount: undefined,
    identifier: undefined,
    timestamp: undefined,
  },
  fiatFee: {
    [CURRENCY.XSGD]: {
      amount: undefined,
      feeType: undefined,
      rate: undefined,
      maxAmount: undefined,
      minAmount: undefined,
    },
    [CURRENCY.USDC]: {
      amount: undefined,
      feeType: undefined,
      rate: undefined,
      maxAmount: undefined,
      minAmount: undefined,
    },
    [CURRENCY.USDT]: {
      amount: undefined,
      feeType: undefined,
      rate: undefined,
      maxAmount: undefined,
      minAmount: undefined,
    },
    [CURRENCY.XUSD]: {
      amount: undefined,
      feeType: undefined,
      rate: undefined,
      maxAmount: undefined,
      minAmount: undefined,
    },
    [CURRENCY.SGD]: {
      amount: undefined,
      feeType: undefined,
      rate: undefined,
      maxAmount: undefined,
      minAmount: undefined,
    },
    [CURRENCY.USD]: {
      amount: undefined,
      feeType: undefined,
      rate: undefined,
      maxAmount: undefined,
      minAmount: undefined,
    },
  },
  hasFetchingFeeError: false,
  isHtsWithdrawalFeeCharging: false,
  isWithdrawalAutomatic: false,
  isConfirmOpen: false,
  is2FaOpen: false,

  visitedGettingStarted: false,

  isHederaUIEnabled: false,
  isPolygonUIEnabled: false,
  isAvalancheUIEnabled: false,
  isTronUIEnabled: false,
  isBnbsmartUIEnabled: false,
  isArbitrumUIEnabled: false,
  isRippleUIEnabled: false,
  isDptRiskModalEnabled: false,
  isRenewAddressAcknowledged: false,
  isUSDTBEP20UIEnabled: false,
  isXsgdSplUIEnabled: false,
  isXusdSplUIEnabled: false,
  isSolanaUIEnabled: false,
}

type State = {
  currentMerchantAccountId: number | null

  isXsgdErc20DepositEnabled: boolean
  isXsgdErc20WithdrawalEnabled: boolean
  isXsgdZrc2DepositEnabled: boolean
  isXsgdZrc2WithdrawalEnabled: boolean
  isXsgdHtsDepositEnabled: boolean
  isXsgdHtsWithdrawalEnabled: boolean
  isXsgdMaticDepositEnabled: boolean
  isXsgdMaticWithdrawalEnabled: boolean
  isXsgdAvaxDepositEnabled: boolean
  isXsgdAvaxWithdrawalEnabled: boolean
  isXsgdArbDepositEnabled: boolean
  isXsgdArbWithdrawalEnabled: boolean
  isXsgdXrpDepositEnabled: boolean
  isXsgdXrpWithdrawalEnabled: boolean
  isUsdcErc20DepositEnabled: boolean
  isUsdcErc20WithdrawalEnabled: boolean
  isUsdtTrc20DepositEnabled: boolean
  isUsdtTrc20WithdrawalEnabled: boolean
  isXusdBep20DepositEnabled: boolean
  isXusdBep20WithdrawalEnabled: boolean
  isXusdErc20DepositEnabled: boolean
  isXusdErc20WithdrawalEnabled: boolean
  isXusdCoachmarkActive: boolean
  isUsdcMaticDepositEnabled: boolean
  isUsdcMaticWithdrawalEnabled: boolean
  isUsdtBep20DepositEnabled: boolean
  isUsdtBep20WithdrawalEnabled: boolean
  isDashboardBannerManagementEnabled: boolean
  isFazzVaForDashboardEnabled: boolean
  isSsoTwoFaAuthenticatorEnabled: boolean
  isTravelRuleDepositDeclarationEnabled: boolean
  isTravelRuleAddrWhitelistingEnabled: boolean
  isDashboardApprovalFlowUIEnabled: boolean
  dashboardBanners: DashboardBanner[]

  tab: string
  transferMethod: TRANSFER_METHOD | null
  selectedCurrency: ACCEPTED_CURRENCY | null
  selectedBlockchain: Blockchain | null
  selectedBlockchainAddress: BlockchainAddress | null
  selectedBankAccount: BankAccount | null
  bankTransferNetwork: BANK_TRANSFER_NETWORK | null
  bankRoutingCode: string | null
  bankIntermediarySwiftCode: string | null

  withdrawAmount: string
  withdrawAmountError: string
  withdrawRequestError: string
  withdrawWalletId: WithdrawWalletIdType
  transferRemark: string

  isStablecoinFeeLoading: boolean
  hasFetchingFeeError: boolean
  stablecoinFee: StablecoinFee
  fiatFee: {
    [key in ACCEPTED_CURRENCY]: FiatFee
  }
  isHtsWithdrawalFeeCharging: boolean
  isWithdrawalAutomatic: boolean
  isConfirmOpen: boolean
  is2FaOpen: boolean

  visitedGettingStarted: boolean

  isHederaUIEnabled: boolean
  isPolygonUIEnabled: boolean
  isAvalancheUIEnabled: boolean
  isTronUIEnabled: boolean
  isBnbsmartUIEnabled: boolean
  isArbitrumUIEnabled: boolean
  isRippleUIEnabled: boolean
  isDptRiskModalEnabled: boolean
  isRenewAddressAcknowledged: boolean
  isUSDTBEP20UIEnabled: boolean
  isXsgdSplUIEnabled: boolean
  isXusdSplUIEnabled: boolean
  isSolanaUIEnabled: boolean
}

export const straitsXLandingPage: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ZRC2_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdZrc2DepositEnabled: action.isXsgdZrc2DepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ERC20_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdErc20DepositEnabled: action.isXsgdErc20DepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_HTS_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdHtsDepositEnabled: action.isXsgdHtsDepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_MATIC_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdMaticDepositEnabled: action.isXsgdMaticDepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_AVAX_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdAvaxDepositEnabled: action.isXsgdAvaxDepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ARB_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdArbDepositEnabled: action.isXsgdArbDepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XRP_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXsgdXrpDepositEnabled: action.isXsgdXrpDepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_TRC20_DEPOSIT_ENABLED: {
      return {
        ...state,
        isUsdtTrc20DepositEnabled: action.isUsdtTrc20DepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XUSD_ERC20_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXusdErc20DepositEnabled: action.isXusdErc20DepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XUSD_ERC20_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXusdErc20WithdrawalEnabled: action.isXusdErc20WithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_BEP20_DEPOSIT_ENABLED: {
      return {
        ...state,
        isXusdBep20DepositEnabled: action.isXusdBep20DepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ZRC2_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdZrc2WithdrawalEnabled: action.isXsgdZrc2WithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ERC20_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdErc20WithdrawalEnabled: action.isXsgdErc20WithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XUSD_COACHMARK_ACTIVE: {
      return {
        ...state,
        isXusdCoachmarkActive: action.isXusdCoachmarkActive,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_HTS_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdHtsWithdrawalEnabled: action.isXsgdHtsWithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_MATIC_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdMaticWithdrawalEnabled: action.isXsgdMaticWithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_AVAX_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdAvaxWithdrawalEnabled: action.isXsgdAvaxWithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ARB_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdArbWithdrawalEnabled: action.isXsgdArbWithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XRP_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXsgdXrpWithdrawalEnabled: action.isXsgdXrpWithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_TRC20_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isUsdtTrc20WithdrawalEnabled: action.isUsdtTrc20WithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_BEP20_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isXusdBep20WithdrawalEnabled: action.isXusdBep20WithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_TAB: {
      return {
        ...state,
        tab: action.tab,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_TRANSFER_METHOD: {
      return {
        ...state,
        transferMethod: action.transferMethod,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_CURRENCY: {
      return {
        ...state,
        selectedCurrency: action.selectedCurrency,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN: {
      return {
        ...state,
        selectedBlockchain: action.selectedBlockchain,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BLOCKCHAIN_ADDRESS: {
      return {
        ...state,
        selectedBlockchainAddress: action.selectedBlockchainAddress,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_BANK_TRANSFER_NETWORK: {
      return {
        ...state,
        bankTransferNetwork: action.bankTransferNetwork,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_SELECTED_BANK_ACCOUNT: {
      return {
        ...state,
        selectedBankAccount: action.selectedBankAccount,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_BANK_ROUTING_CODE: {
      return {
        ...state,
        bankRoutingCode: action.bankRoutingCode,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_BANK_INTERMEDIARY_SWIFT_CODE: {
      return {
        ...state,
        bankIntermediarySwiftCode: action.bankIntermediarySwiftCode,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_WITHDRAW_AMOUNT: {
      return {
        ...state,
        withdrawAmount: action.amount,
        withdrawAmountError: action.withdrawAmountError,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_WITHDRAW_WALLET_ID: {
      return {
        ...state,
        withdrawWalletId: action.withdrawWalletId,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_TRANSFER_REMARK: {
      return {
        ...state,
        transferRemark: action.transferRemark,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_STABLECOIN_FEE_LOADING: {
      return {
        ...state,
        isStablecoinFeeLoading: action.isStablecoinFeeLoading,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_STABLECOIN_FEE: {
      return {
        ...state,
        isStablecoinFeeLoading: false,
        stablecoinFee: {
          amount: action.amount,
          identifier: action.identifier,
          timestamp: action.timestamp,
        },
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_FIAT_FEE: {
      return {
        ...state,
        fiatFee: {
          ...state.fiatFee,
          [action.stablecoin]: {
            amount: action.amount,
            feeType: action.feeType,
            rate: action.rate,
            maxAmount: action.maxAmount,
            minAmount: action.minAmount,
          },
        },
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_HTS_WITHDRAWAL_FEE_CHARGING: {
      return {
        ...state,
        isHtsWithdrawalFeeCharging: action.isHtsWithdrawalFeeCharging,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_WITHDRAWAL_AUTOMATIC: {
      return {
        ...state,
        isWithdrawalAutomatic: action.isWithdrawalAutomatic,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_CONFIRM_MODAL_OPEN: {
      return {
        ...state,
        isConfirmOpen: action.open,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_2_FA_MODAL_OPEN: {
      return {
        ...state,
        is2FaOpen: action.open,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.CREATE_WITHDRAWAL_REQUEST: {
      return {
        ...state,
        withdrawRequestError: action.error,
        isLoading: false,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_VISITED_GETTING_STARTED: {
      return {
        ...state,
        visitedGettingStarted: action.value,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_CURRENT_MERCHANT_ACCOUNT_ID: {
      return {
        ...state,
        currentMerchantAccountId: action.currentMerchantAccountId,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_HEDERA_UI_ENABLED: {
      return {
        ...state,
        isHederaUIEnabled: action.isHederaUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_POLYGON_UI_ENABLED: {
      return {
        ...state,
        isPolygonUIEnabled: action.isPolygonUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_AVALANCHE_UI_ENABLED: {
      return {
        ...state,
        isAvalancheUIEnabled: action.isAvalancheUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_TRON_UI_ENABLED: {
      return {
        ...state,
        isTronUIEnabled: action.isTronUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_BNBSMART_UI_ENABLED: {
      return {
        ...state,
        isBnbsmartUIEnabled: action.isBnbsmartUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_ARBITRUM_UI_ENABLED: {
      return {
        ...state,
        isArbitrumUIEnabled: action.isArbitrumUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_USDT_BEP20_UI_ENABLED: {
      return {
        ...state,
        isUSDTBEP20UIEnabled: action.isUSDTBEP20UIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_RIPPLE_UI_ENABLED: {
      return {
        ...state,
        isRippleUIEnabled: action.isRippleUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XSGD_SPL_UI_ENABLED: {
      return {
        ...state,
        isXsgdSplUIEnabled: action.isXsgdSplUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_XUSD_SPL_UI_ENABLED: {
      return {
        ...state,
        isXusdSplUIEnabled: action.isXusdSplUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_SOLANA_UI_ENABLED: {
      return {
        ...state,
        isSolanaUIEnabled: action.isSolanaUIEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_USDC_MATIC_DEPOSIT_ENABLED: {
      return {
        ...state,
        isUsdcMaticDepositEnabled: action.isUsdcMaticDepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_USDC_MATIC_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isUsdcMaticWithdrawalEnabled: action.isUsdcMaticWithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_USDT_BEP20_DEPOSIT_ENABLED: {
      return {
        ...state,
        isUsdtBep20DepositEnabled: action.isUsdtBep20DepositEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_USDT_BEP20_WITHDRAWAL_ENABLED: {
      return {
        ...state,
        isUsdtBep20WithdrawalEnabled: action.isUsdtBep20WithdrawalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_HAS_FETCHING_FEE_ERROR: {
      return {
        ...state,
        hasFetchingFeeError: action.hasError,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_DASHBOARD_BANNER_MANAGEMENT_ENABLED: {
      return {
        ...state,
        isDashboardBannerManagementEnabled: action.isDashboardBannerManagementEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_SSO_TWO_FA_AUTHENTICATED_ENABLED: {
      return {
        ...state,
        isSsoTwoFaAuthenticatorEnabled: action.isSsoTwoFaAuthenticatorEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_FAZZ_VA_FOR_DASHBOARD_ENABLED: {
      return {
        ...state,
        isFazzVaForDashboardEnabled: action.isFazzVaForDashboardEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_DASHBOARD_BANNERS: {
      return {
        ...state,
        dashboardBanners: action.dashboardBanners,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_DPT_RISK_MODAL_ENABLED: {
      return {
        ...state,
        isDptRiskModalEnabled: action.isDptRiskModalEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_TRAVEL_RULE_DEPOSIT_DECLARATION_ENABLED: {
      return {
        ...state,
        isTravelRuleDepositDeclarationEnabled: action.isTravelRuleDepositDeclarationEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_TRAVEL_RULE_ADDR_WHITELISTING_ENABLED: {
      return {
        ...state,
        isTravelRuleAddrWhitelistingEnabled: action.isTravelRuleAddrWhitelistingEnabled,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_RENEW_ADDRESS_ACKNOWLEDGED: {
      return {
        ...state,
        isRenewAddressAcknowledged: action.isRenewAddressAcknowledged,
      }
    }

    case STRAITSX_LANDING_PAGE_ACTIONS.SET_IS_DASHBOARD_APPROVAL_FLOW_UI_ENABLED: {
      return {
        ...state,
        isDashboardApprovalFlowUIEnabled: action.isDashboardApprovalFlowUIEnabled,
      }
    }

    default:
      // TODO(benedictkhoo): remove after domain stores are merged into common stores
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
      return (commonLandingPageReducer(state as any, action as any) as unknown) as State
  }
}
